import React from "react";
import Helmet from "react-helmet";
import { Link, graphql } from "gatsby";

import * as styles from "./pricing.module.css";
import BorderButton from "../../components/BorderButton";
import PagesTemplate from "../_template";

export const query = graphql`
  {
    site {
      siteMetadata {
        siteTitle
        loginLink
        signupLink
      }
    }
  }
`;

export default class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      annualToggle: false,
    };

    this._toggleAnnual = this._toggleAnnual.bind(this);
  }

  render() {
    const isAt = this.state.annualToggle;
    const annualBonus = isAt ? "Billed annually, 1 month free" : "\u00A0";

    return (
      <PagesTemplate>
        <div>
          <Helmet
            title={`Outreach Pricing | ${this.props.data.site.siteMetadata.siteTitle}`}
            meta={[
              {
                name: "description",
                content:
                  "Choose from several different plans to suite your business when using O3",
              },
              {
                name: "keywords",
                content:
                  "O3, O3 outreach, outreach pricing, business analytics, customer satisfaction, customer experience, text message surveys, digital health, patient satisfaction, outcome measures",
              },
            ]}
          />

          <section className="mw8 center pa3">
            <h1 className="f1 lh-title tc pb3">
              Pick the perfect package for your business
            </h1>

            <p className="f4 lh-copy tc">
              All plans include ready-to-go NPS<sup>®</sup> surveys, unlimited
              users, instant notifications, and amazing support.
            </p>

            <p className="f5 lh-copy tc">
              Backed by our <strong>30-day money-back guarantee</strong>, you
              can rest easy knowing that we stand behind our product.
            </p>

            <div className="tc dt mw6 center mt5 mb3">
              <span className="f4 tr dtc v-mid">Monthly Billing</span>
              <div className="dtc ph2">
                <div className={styles.onoffswitch}>
                  <input
                    type="checkbox"
                    name="onoffswitch"
                    className={styles.onoffswitch_checkbox}
                    id="myonoffswitch"
                    checked={this.state.annualToggle}
                    onChange={this._toggleAnnual}
                  />
                  <label
                    className={styles.onoffswitch_label}
                    htmlFor="myonoffswitch"
                  />
                </div>
              </div>
              <span className="f4 dtc v-mid">
                Annual Billing (A Month Free)
              </span>
            </div>

            <div className="cf">
              <div className="tc mv3">
                <strong>All plans include 5,000 surveys a month</strong>
              </div>

              <div className="pricing-box fl w-50-m w-25-l tc">
                <div className="mr3 mb3 ba b--light-blue">
                  <h3 className="f5 ttu tracked bg-light-gray mt0 pa3">
                    Starter Business
                  </h3>
                  <h4>
                    <span className="f1">${isAt ? "90" : "99"}</span>{" "}
                    <span className="f6 black-20"> / month</span>
                  </h4>
                  <h5 className="f6 black-60 i mv0">{annualBonus}</h5>
                  <ul className="list pl0 mt1">
                    {/* <li className="mh3 pv2 bb bw1 b--light-gray">
                    <strong>Send 5,000 surveys</strong>
                  </li> */}
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Send a text survey after every customer interaction
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Online Dashboard
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Instant Notifications
                    </li>
                    <li className="mh3 pv2">Private Phone Number</li>
                  </ul>
                  <BorderButton
                    link={`${
                      this.props.data.site.siteMetadata.signupLink
                    }?planType=starter&billingFrequency=${
                      this.state.annualToggle ? "annual" : "monthly"
                    }`}
                    label="Start a 7-day Free Trial"
                    primary
                  />
                </div>
              </div>

              <div className="pricing-box fl w-50-m w-25-l tc">
                <div className="mr3 mb3 ba b--light-blue">
                  <h3 className="f5 ttu tracked bg-lightest-blue mt0 pa3">
                    Small Business
                  </h3>
                  <h4>
                    <span className="f1">${isAt ? "228" : "249"}</span>{" "}
                    <span className="f6 black-20"> / month</span>
                  </h4>
                  <h5 className="f6 black-60 i mv0">{annualBonus}</h5>
                  <ul className="list pl0 mt1">
                    {/* <li className="mh3 pv2 bb bw1 b--light-gray">
                    <strong>Send 5,000 surveys</strong>
                  </li> */}
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Send a text survey after every customer interaction
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Online Dashboard
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Instant Notifications
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Private Phone Number
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray fw5">
                      <i className="fa fa-plus green" /> Boost Online Reviews
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray fw5">
                      <i className="fa fa-plus green" /> Per-employee Scores
                    </li>
                    <li className="mh3 pv2 fw5">
                      <i className="fa fa-plus green" /> Track Follow-ups
                    </li>
                  </ul>
                  <BorderButton
                    link={`${
                      this.props.data.site.siteMetadata.signupLink
                    }?planType=small&billingFrequency=${
                      this.state.annualToggle ? "annual" : "monthly"
                    }`}
                    label="Start a 7-day Free Trial"
                    primary
                  />
                </div>
              </div>

              <div className="pricing-box fl w-50-m w-25-l tc">
                <div className="mr3 mb3 ba b--light-blue">
                  <h3 className="f5 ttu tracked white bg-light-blue mt0 pa3">
                    Medium Business
                  </h3>
                  <h4>
                    <span className="f1">${isAt ? "365" : "399"}</span>{" "}
                    <span className="f6 black-20"> / month</span>
                  </h4>
                  <h5 className="f6 black-60 i mv0">{annualBonus}</h5>
                  <ul className="list pl0 mt1">
                    {/* <li className="mh3 pv2 bb bw1 b--light-gray">
                    <strong>Send 5,000 surveys</strong>
                  </li> */}
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Send a text survey after every customer interaction
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Online Dashboard
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Instant Notifications
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Private Phone Number
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Boost Online Reviews
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Per-employee Scores
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Track Follow-ups
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray fw5">
                      <i className="fa fa-plus green" /> Multiple Question Types
                    </li>
                    <li className="mh3 pv2 fw5">
                      <i className="fa fa-plus green" /> Custom Text Message
                      Campaigns
                    </li>
                  </ul>
                  <BorderButton
                    link={`${
                      this.props.data.site.siteMetadata.signupLink
                    }?planType=medium&billingFrequency=${
                      this.state.annualToggle ? "annual" : "monthly"
                    }`}
                    label="Start a 7-day Free Trial"
                    primary
                  />
                </div>
              </div>

              <div className="pricing-box fl w-50-m w-25-l tc">
                <div className="ba b--light-blue">
                  <h3 className="f5 ttu tracked white bg-blue mt0 pa3">
                    Large Business
                  </h3>
                  <h4>
                    <span className="f1">${isAt ? "549" : "599"}</span>{" "}
                    <span className="f6 black-20">/ month</span>
                  </h4>
                  <h5 className="f6 black-60 i mv0">{annualBonus}</h5>
                  <ul className="list pl0 mt1">
                    {/* <li className="mh3 pv2 bb bw1 b--light-gray">
                    <strong>Send 10,000 surveys</strong>
                  </li> */}
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Send a text survey after every customer interaction
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Online Dashboard
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Instant Notifications
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Private Phone Number
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Boost Online Reviews
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Per-employee Scores
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Track Follow-ups
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Multiple Question Types
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray">
                      Custom Text Message Campaigns
                    </li>
                    <li className="mh3 pv2 bb bw1 b--light-gray fw5">
                      <i className="fa fa-plus green" /> Send 5,000 add&apos;l
                      surveys
                    </li>
                    <li className="mh3 pv2 fw5">
                      <i className="fa fa-plus green" /> Priority Support
                    </li>
                  </ul>
                  <BorderButton
                    link={`${
                      this.props.data.site.siteMetadata.signupLink
                    }?planType=large&billingFrequency=${
                      this.state.annualToggle ? "annual" : "monthly"
                    }`}
                    label="Start a 7-day Free Trial"
                    primary
                  />
                </div>
              </div>
            </div>

            <div className="tc pv4">
              <p>
                <strong>
                  Many locations or need to send more than 10,000 surveys a
                  month?
                </strong>
              </p>
              <p>
                <Link to="/contact/">
                  Get in touch with us to craft the perfect solution for you.
                </Link>
              </p>
            </div>
          </section>
        </div>
      </PagesTemplate>
    );
  }

  _toggleAnnual() {
    this.setState({ annualToggle: !this.state.annualToggle });
  }
}
